import { Dimensions, StyleSheet, Platform } from 'react-native';
import { parseValue, isMentionPartType, Part, PartType } from 'react-native-controlled-mentions';
import Hyperlink from 'react-native-hyperlink';
import { useNavigation } from '@react-navigation/native';
import { NativeStackNavigationProp } from '@react-navigation/native-stack';

import { Text, TextProps, colors, spacing } from '@pletly/ui';
import { RootStackParamList } from '%navigation/types';

interface Props extends Pick<TextProps, 'category'> {
	text: string;
}

export const MentionText = ({ text, category = 's1' }: Props) => {
	const { navigate } = useNavigation<NativeStackNavigationProp<RootStackParamList>>();

	const handleMentionClick = (id?: string) => {
		if (!id) {
			return;
		}
		navigate('Profile', { userId: id });
	};

	const renderPart = (part: Part, index: number) => {
		if (part.partType && isMentionPartType(part.partType)) {
			return (
				<Text
					key={index}
					category={category}
					style={part.partType.textStyle}
					onPress={() => handleMentionClick(part.data?.id)}
				>
					{part.text}
				</Text>
			);
		}

		return (
			<Hyperlink linkDefault linkStyle={styles.link} key={index}>
				<Text category={category} style={styles.linkText}>
					{part.text}
				</Text>
			</Hyperlink>
		);
	};

	const renderValue = (value: string, partTypes: PartType[]) => {
		const { parts } = parseValue(value, partTypes);

		return parts.map(renderPart);
	};

	const content = renderValue(text, [
		{
			trigger: '@',
			textStyle: styles.mentionStyle,
		},
	]);

	return <>{content}</>;
};

const styles = StyleSheet.create({
	mentionStyle: {
		textDecorationLine: 'underline',
	},
	link: {
		color: colors.secondary,
	},
	linkText: {
		...Platform.select({
			android: {
				maxWidth: Dimensions.get('screen').width - 2 * spacing(),
			},
		}),
	},
});
